import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PlayerResponsiveContainer } from '../../styles';
import { getPlayerExecutionProps } from './service';
const emptyFunction = () => { };
const Iframe = ({ link, sandbox, allowProps, height, css, onUpdateLoading, }) => {
    return (_jsx("iframe", { width: "100%", src: link, frameBorder: "0", allow: allowProps, allowFullScreen: true, sandbox: sandbox
            ? sandbox
            : 'allow-scripts allow-same-origin allow-presentation allow-popups', height: height, style: css, onLoad: () => onUpdateLoading(false) }, link));
};
export const Player = ({ link, category, onProviderNotFound = emptyFunction, onError = emptyFunction, onUpdateLoading = emptyFunction, }) => {
    const [consolidatedProps, setConsolidatedProps] = useState();
    useEffect(() => {
        const playerProps = safeGetPlayerExecutionProps(link, onError, category);
        if (playerProps) {
            setConsolidatedProps({ ...playerProps, onUpdateLoading });
            onUpdateLoading(true);
        }
        else {
            setConsolidatedProps(undefined);
            onProviderNotFound();
        }
    }, [link, onError, category, onUpdateLoading, onProviderNotFound]);
    return consolidatedProps ? (consolidatedProps.responsive ? (_jsx(Iframe, { ...consolidatedProps })) : (_jsx(PlayerResponsiveContainer, { aspect: consolidatedProps.aspect, children: _jsx(Iframe, { ...consolidatedProps }) }))) : null;
};
const safeGetPlayerExecutionProps = (link, onError, category) => {
    try {
        return getPlayerExecutionProps(link, category);
    }
    catch (e) {
        onError();
        return undefined;
    }
};
